import details from './details'

export default {
  title: 'Puan Indonesia',
  slug: 'puan-indonesia',
  createdAt: '1610445343174',
  description:
    'PUAN berkisah tentang perempuan Indonesia, pergulatan keseharian, keringat, air mata, tawa, & kecintaannya, bersama @mardiyahchamim, penulis dan pejalan.',
  details,
  tint: '#EBE1DF'
}
